import { useSession } from 'src/contexts/SessionContext';

import { CollectionTags } from './utils';

export function useCollectionTags(): CollectionTags {
  const { session } = useSession();

  return {
    productTags: session?.productTags,
    packageTags: session?.packageTags,
  };
}
